module.exports = __webpack_public_path__ + "static/media/ic_nuxtjs.5174f4f9.png";